import { render } from "./process.vue?vue&type=template&id=72d0a0ec&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=72d0a0ec&lang=scss&scoped=true"
import "./process.vue?vue&type=style&index=1&id=72d0a0ec&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d0a0ec"]])

export default __exports__